import * as React from 'react';
import propz from 'propz';
import { FunctionComponent } from 'react';
import { SchoolHouse } from '../../models/house';

interface Props {
  house: SchoolHouse;
}

const ROWS = [
  { title: 'Name', field: 'name' },
  { title: 'Description', field: 'description' },
  { title: 'Colours', field: 'colors' }
];

export const HouseSummary: FunctionComponent<Props> = ({ house }) => {
  const logoUrl = house.pic || '/dist/images/empty_pic_uploader_box.png';

  const rows = ROWS.map((row, index) => {
    let contentCell: React.ReactNode;

    switch (row.field) {
      case 'colors': {
        const hasColors = Array.isArray(house.colors) && house.colors.length > 0;
        contentCell = hasColors
          ? house.colors.map((color, idx) => (
              <div key={idx} className="eDataList_listItemColor" style={{ background: color }} />
            ))
          : null;
        break;
      }
      default:
        contentCell = propz.get(house, row.field.split('.'), '');
    }

    return (
      <tr key={`house_summary_${index}`}>
        <td>{row.title}</td>
        <td>{contentCell}</td>
      </tr>
    );
  });

  return (
    <>
      <div className="house-summary-logo mb-3" style={{ textAlign: 'center' }}>
        <img
          src={logoUrl}
          alt={`${house.name} logo`}
          style={{
            width: 80,
            height: 80,
            objectFit: 'cover',
            borderRadius: 8
          }}
        />
      </div>
      <table className="table table-sm mPre mVerticalAlignMiddle">
        <tbody>{rows}</tbody>
      </table>
    </>
  );
};

HouseSummary.displayName = 'HouseSummary';

